module.exports = __webpack_public_path__ + "img/logo.ee9e3eec.png";